export default {
    closeCreditAccountSuccessReceipt: {
        dataTrackId: 'close-credit-account-success-receipt',
        dataTrackLinkname: 'avslutt konto - suksess kvittering',
    },
    closeCreditAccountSuccessOk: {
        dataTrackId: 'close-credit-account-success-ok',
        dataTrackLinkname: 'avslutt konto suksess - ok',
    },
    closeCreditAccountCancel: {
        dataTrackId: 'close-credit-account-cancel',
        dataTrackLinkname: 'avbryt avslutt konto',
    },
    closeCreditAccountSubmit: {
        dataTrackId: 'close-credit-account-submit',
        dataTrackLinkname: 'bekreft avslutning av konto',
    },
    selectAccountToCloseOption: {
        dataTrackId: 'select-account-to-close-option',
        dataTrackLinkname: 'avslutt konto - kontoalternativ',
    },
    selectAccountToClose: {
        dataTrackId: 'select-account-to-close',
        dataTrackLinkname: 'velg konto a avslutte',
    },
    cancelCloseCreditAccount: {
        dataTrackId: 'cancel-close-credit-account',
        dataTrackLinkname: 'avbryt avslutt konto',
    },
    closeCreditAccountToTransferForm: {
        dataTrackId: 'close-credit-account-to-transfer-form',
        dataTrackLinkname: 'neste',
    },
    noTransferAccountSelectedWarning: {
        dataTrackId: 'no-transfer-account-selected-warning',
        dataTrackLinkname: 'advarsel anbefaler a velge overforingskonto',
    },
    selectAccountToTransferRemainingBalanceToOption: {
        dataTrackId: 'select-account-to-transfer-remaining-balance-to-option',
        dataTrackLinkname: 'kontoalternativ',
    },
    selectAccountToTransferRemainingBalanceToOptionCustom: {
        dataTrackId: 'select-account-to-transfer-remaining-balance-to-option-custom',
        dataTrackLinkname: 'kontoalternativ - skriv inn eget',
    },
    selectAccountToTransferRemainingBalanceToOptionNone: {
        dataTrackId: 'select-account-to-transfer-remaining-balance-to-option-none',
        dataTrackLinkname: 'kontoalternativ - ingen',
    },
    selectAccountToTransferRemainingBalanceTo: {
        dataTrackId: 'select-account-to-transfer-remaining-balance-to',
        dataTrackLinkname: 'velg hvilken konto du vil overfore resterende saldo til',
    },
    customAccountNumberInput: {
        dataTrackId: 'custom-account-number-input',
        dataTrackLinkname: 'skriv inn eget kontonummer',
    },
    closeCreditAccountToConfirm: {
        dataTrackId: 'close-credit-account-to-confirm',
        dataTrackLinkname: 'neste',
    },
};
